
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/article/[newsId]",
      function () {
        return require("private-next-pages/news/article/[newsId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/article/[newsId]"])
      });
    }
  